import {Combo} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";

export default class SwivuSettingsCombo extends Combo {
  static get $name() {
    return "SwivuSettingsCombo";
  }

  static get configurable() {
    return {
      createOnUnmatched: true
    }
  }

  static get type() {
    return WIDGET_KEYS.settingsCombo;
  }

  // since we want to open settings editor in settings combos
  addNewRecord() {
    const me = this,
      { _picker : picker, }  = me,
      lastValue = me.value;
    this.onClickEditMessage();
    me.value = lastValue;
    picker?.hide();
  }

  //Overriding add new item tooltip
  onStoreFilter(event) {
    super.onStoreFilter(event);
    const { source : store } = event;
    const
      me        = this,
      picker    = me._picker,
      dataset   = picker?.element.dataset,
      { count } = store;

    // If createOnUnmatched, we add a hint
    if (dataset) {
      if (me.createOnUnmatched && !count) {
        //Overriding hint on unmatched enabled
        dataset.addNewValue = me.editMessage;
      }
      else {
        delete dataset?.addNewValue;
      }
    }
  }

  onClickEditMessage() {
    if (this.onSwivuEditMessage) {
      this.up((parentItem) => {
        const onClickSwivuEditMessage = parentItem[this.onSwivuEditMessage];
        if (typeof onClickSwivuEditMessage === "function") {
          onClickSwivuEditMessage.call(parentItem, this);
        }
      })
    }
  }
}

SwivuSettingsCombo.initClass();